import {
  productPaymentConfigService,
  type CreateProductPaymentMethodPayload,
  type UpdateProductPaymentMethodPayload,
} from '@/services';
import { useMutation } from '@tanstack/react-query';
import { useInvalidatePaymentSettings } from './use-invalidate-payment-settings.hook';

export type SavePaymentMethodInput =
  | { kind: 'create'; payload: CreateProductPaymentMethodPayload }
  | {
      kind: 'update';
      code: string;
      payload: UpdateProductPaymentMethodPayload;
    };

/** Adiciona ou edita uma forma do catálogo. Lança com a mensagem do servidor. */
export function useSavePaymentMethod(productCode: string) {
  const invalidate = useInvalidatePaymentSettings();

  return useMutation({
    mutationFn: async (input: SavePaymentMethodInput) => {
      const response =
        input.kind === 'create'
          ? await productPaymentConfigService.createPaymentMethod(
              productCode,
              input.payload
            )
          : await productPaymentConfigService.updatePaymentMethod(
              productCode,
              input.code,
              input.payload
            );
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Não foi possível salvar a forma de pagamento.'
        );
      }
      return response.data;
    },
    onSuccess: invalidate,
  });
}
